import { STORE_TIER, StoreTier } from "./store-tier"

export const STORE_FEATURE = {
  INSPECTION: "INSPECTION",
  ADDON_ORDER: "ADDON_ORDER",
  ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
  SERVICE_REMINDERS: "SERVICE_REMINDERS",
  INSIGHTS: "INSIGHTS",
  PREVIOUS_JOBS_TAB: "PREVIOUS_JOBS_TAB",
} as const

export type StoreFeature = (typeof STORE_FEATURE)[keyof typeof STORE_FEATURE]

const FEATURES_BY_TIER: Record<StoreTier, ReadonlySet<StoreFeature>> = {
  [STORE_TIER.FREE]: new Set(),
  [STORE_TIER.START]: new Set(),
  [STORE_TIER.ALFRED]: new Set(Object.values(STORE_FEATURE)),
}

export const hasStoreFeature = (
  tier: StoreTier | null,
  feature: StoreFeature,
): boolean => (tier ? FEATURES_BY_TIER[tier].has(feature) : false)
